var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.775,
    y1: 0.086,
    x2: 0.148,
    y2: 0.829,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74adff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#235cae"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13693",
    "data-name": "Group 13693",
    transform: "translate(-12 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13051",
    "data-name": "Path 13051",
    d: "M28,0A28,28,0,1,1,0,28,28,28,0,0,1,28,0Z",
    transform: "translate(12 12)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5891",
    transform: "translate(243 852.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shapes",
    transform: "translate(-218 -826.72)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect11",
    width: 6.432,
    height: 18.891,
    transform: "translate(0.379 9.109)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13-0",
    d: "M59.638,54.28a3.28,3.28,0,1,0-.085,6.528h.042a3.281,3.281,0,1,0,.044-6.528Z",
    transform: "translate(-56 -54.28)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "M206.49,172.6a6.413,6.413,0,0,0-5.8,3.119v-2.675h-6.43c.085,1.772,0,18.891,0,18.891h6.43v-10.55a4.2,4.2,0,0,1,.212-1.533,3.512,3.512,0,0,1,3.3-2.3c2.326,0,3.258,1.733,3.258,4.271v10.107h6.431V181.1C213.894,175.3,210.721,172.6,206.49,172.6Z",
    transform: "translate(-183.894 -163.936)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f8bbc91ed53e50d2bb3a5bffa4035c10.svg";
export { ForwardRef as ReactComponent };